module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/vi-5b3ac115660577661d1e468dbac9fd95.jpg";